import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"icon-info\">\n    <g transform=\"translate(1 1)\" fill=\"none\" fill-rule=\"evenodd\">\n        <circle stroke=\"#13B3E3\" cx=\"12\" cy=\"12\" r=\"12\" />\n        <path d=\"M11.56 19h1.638V9.136H11.56V19zm.846-11.466c.594 0 1.08-.486 1.08-1.116 0-.63-.486-1.116-1.08-1.116-.63 0-1.116.486-1.116 1.116 0 .63.486 1.116 1.116 1.116z\" fill=\"#13B3E3\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol